module.exports = __webpack_public_path__ + "static/media/terms_and_conditions.pdf";